import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

// Services
import { SessionStorageService, CatalogService } from '../../../common/modules/core/services';
import { ChildrenServices } from '../../services/ChildrenServices';

@Component({
    template: require('./ChildrenListComponent.html'),
    styles: [require('./ChildrenListComponent.sass')]
})

export class ChildrenListComponent implements OnInit {
    campsChildren : any = [];

    constructor(
        private childrenServices: ChildrenServices,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.getChildren();
    }
    // End of Init

    // Get all children
    getChildren() {
        this.childrenServices.getChildren().subscribe(
            result => {
                this.campsChildren = result;
            },
            error => {

            }
        )
    }

    /**
     * 
     * Click event on Child list
     * 
     * @memberOf ChildrenListComponent
     */
    toChildAttendance(id:number) {
        this.router.navigate(['/bus-attendance', id])
    }
}


// WEBPACK FOOTER //
// ./src/bus/parent/children-list/ChildrenListComponent.ts